import React from 'react';
import { useSelector } from "react-redux";
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import { CaseForms, UserRoleEnum } from "../../../../helpers/enums";
import { SwitchUser } from "../../../../helpers/helpers";
import { useTranslation } from "react-i18next";
import './SubentroCase.scss';
import digitalizzazioneCustomModalSuccess from "../../../CaseGenerator/custom-success-modal/digitalizzazioneCustomModalSuccess";

const SubentroCase = () => {
  const auth = useSelector((state) => state.auth);
  const {user} = auth;
  const userProfile = SwitchUser(auth);
  const role = userProfile ? userProfile.role : null;
  const { t } = useTranslation();
  const blockForm = userProfile.isCondominiumAdminDisabled && role === UserRoleEnum.CONDOMINIUM_ADMIN;
  return (
    <div className="SubentroCase" data-testid="SubentroCase">
      <CaseGenerator
        type={CaseForms.Subentro}
        block={blockForm}
        signDigital={user.role !== 'MUNICIPAL_OPERATOR' ? true : false} // this is mandatory if you want custom success modal
        successModalCustom={
          (props) => digitalizzazioneCustomModalSuccess({t:t,content: "cases.digitalization.success", ...props})
        }
        excludeSteps={user.role === 'MUNICIPAL_OPERATOR' ? [9]: []}
        blockText={blockForm && t("associate-contract.block-view")}
      />
    </div>
  );
};

export default SubentroCase;

